(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-coupon-new"] && !window.DesignMode) return;
  try {
    
document.getElementById('show-more-logos')?.addEventListener('click', function () {
  const allLogos = document.querySelectorAll('.coupon-image-main');
  const maxVisibleLogos = 12; 

  const areLogosHidden = Array.from(allLogos).some(logo => !logo.classList.contains('visible'));

  if (areLogosHidden) {

    allLogos.forEach(logo => logo.classList.add('visible'));
    this.textContent = 'Show Less';
  } else {
 
    allLogos.forEach((logo, index) => {
      if (index < maxVisibleLogos) {
        logo.classList.add('visible');
      } else {
        logo.classList.remove('visible');
      }
    });
    this.textContent = 'Show More';
  }
});
 let add_copyes = document.querySelectorAll(".coupon-code-copy");

  add_copyes.forEach(item =>{
  
    // var title = item.querySelector('.offer-code_copy');
	var content = item.querySelector('.custom_addcopied');
	
	item.addEventListener('click',() => {
	 for(let i=0;i<add_copyes.length;i++){
      if(add_copyes[i] == item){
		item.classList.add('active');
	 }
	 else{
		add_copyes[i].classList.remove('active');

	}
       }
	});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-logo-list"] && !window.DesignMode) return;
  try {
    
document.getElementById('show-more-logos')?.addEventListener('click', function () {
  const allLogos = document.querySelectorAll('.logo-list__item');
  const maxVisibleLogos = 14; 

  const areLogosHidden = Array.from(allLogos).some(logo => !logo.classList.contains('visible'));

  if (areLogosHidden) {

    allLogos.forEach(logo => logo.classList.add('visible'));
    this.textContent = 'Show Less';
  } else {
 
    allLogos.forEach((logo, index) => {
      if (index < maxVisibleLogos) {
        logo.classList.add('visible');
      } else {
        logo.classList.remove('visible');
      }
    });
    this.textContent = 'Show More';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-our-brands"] && !window.DesignMode) return;
  try {
    
document.getElementById('show-more-logos')?.addEventListener('click', function () {
  const allLogos = document.querySelectorAll('.off-percentage');
  const maxVisibleLogos = 12; 

  const areLogosHidden = Array.from(allLogos).some(logo => !logo.classList.contains('visible'));

  if (areLogosHidden) {

    allLogos.forEach(logo => logo.classList.add('visible'));
    this.textContent = 'Show Less';
  } else {
 
    allLogos.forEach((logo, index) => {
      if (index < maxVisibleLogos) {
        logo.classList.add('visible');
      } else {
        logo.classList.remove('visible');
      }
    });
    this.textContent = 'Show More';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
